import type { ViewId } from '../state';
import { Icon } from '../components/Icon';

type Props = { onNavigate: (id: ViewId) => void };

/**
 * Games hub. Grouped per Skufla request: «Быстрые» (solo, instant) vs
 * «По сети» (multiplayer, queue/match). BOG BATTLE is the headline
 * social game so it gets the wide gold-bordered card on top of its
 * group instead of a plain row.
 */
export function GamesView({ onNavigate }: Props) {
    return (
        <div className="view">
            <h2 className="text-center fw-900" style={{ fontSize: 16, letterSpacing: 2 }}>
                РАЗДЕЛ ИГР
            </h2>

            <SectionTitle>Быстрые</SectionTitle>

            <div
                className="games-list-card"
                style={{ borderColor: 'var(--green)' }}
                onClick={() => onNavigate('boxes')}
                role="button"
            >
                <span className="g-icon"><Icon name="box" size={28} color="var(--green)" /></span>
                <span className="g-title text-green">BSP BOXES</span>
            </div>

            <div
                className="games-list-card"
                style={{ borderColor: 'var(--accent)' }}
                onClick={() => onNavigate('fastGiveaway')}
                role="button"
            >
                <span className="g-icon"><Icon name="lightning" size={28} color="var(--accent)" /></span>
                <span className="g-title text-accent">FAST GIVEAWAY</span>
            </div>

            <div
                className="games-list-card"
                style={{ borderColor: '#fff' }}
                onClick={() => onNavigate('game667')}
                role="button"
            >
                <span className="g-icon"><Icon name="star" size={28} color="#fff" filled /></span>
                <span
                    className="g-title"
                    style={{ color: '#fff', textShadow: '0 0 10px rgba(255, 0, 0, 0.8)' }}
                >
                    ИГРА 667
                </span>
                <span className="g-tag">ХАРДКОР</span>
            </div>

            <SectionTitle>По сети</SectionTitle>

            {/* Headline social game — wider tile, gold halo. */}
            <div
                className="games-list-card games-hero"
                onClick={() => onNavigate('bogBattle')}
                role="button"
            >
                <span className="g-icon"><Icon name="sword" size={34} color="var(--red)" /></span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <span className="g-title text-red">BOG BATTLE</span>
                    <span className="text-muted f-12">сразись 1:1 / до 6 игроков</span>
                </div>
            </div>

            <div
                className="games-list-card"
                style={{ borderColor: 'var(--accent)' }}
                onClick={() => onNavigate('piggyBank')}
                role="button"
            >
                <span className="g-icon"><Icon name="piggy" size={28} color="var(--accent)" /></span>
                <span className="g-title text-accent">PIGGY BANK</span>
                <span className="g-tag">30 ИГРОКОВ</span>
            </div>

            <button type="button" className="back-btn" onClick={() => onNavigate('menu')}>
                НАЗАД В МЕНЮ
            </button>
        </div>
    );
}

function SectionTitle({ children }: { children: React.ReactNode }) {
    return (
        <div
            className="text-muted fw-900"
            style={{
                fontSize: 10,
                letterSpacing: 1.5,
                textTransform: 'uppercase',
                margin: '12px 0 -2px',
                opacity: 0.6,
            }}
        >
            {children}
        </div>
    );
}
